const top_section_img = document.querySelector(".top-section img"),
top_section_texte = document.querySelector(".top-section .text");

const top_section_img_appear = ()=>{
    top_section_texte.style.opacity = 1;
    top_section_texte.style.transform = "translateX(0)";
    top_section_img.style.opacity = 1;
    top_section_img.style.transform = "translateX(0) scale(1)";
};

window.innerWidth>900 && top_section_img_appear()
